import axiosHelper from "./AxiosApi";
export default class ConfigurationService {
  public GetAppSettings(): Promise<String> {
    return axiosHelper.get(`/AppSettings/Get`);
  }
}
